import { AssetUpsertModel } from './bulk-add-asset.model';

export class AssetUpsertArrayModel {
  upsertArray: AssetUpsertModel[];
}
